import BreadcrumbView from "../common/breadcrumb/breadcrumb.html";
import MailingsListView from "./mailings-list.html";


angular.module("mailings", [])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('mailings', {
                url: "/mailings",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView,
            })
            .state('mailings.list', {
                url: "/list",
                controller: "MailingsListCtrl",
                template: MailingsListView,
                resolve: {
                    entity_type: [function () { return null; }],
                },
                cache: false,
                data: { pageTitle: 'Comunicaciones' },
                requiredPermission: ["MAILINGS_READ"]
            })

        ;
    }])
;